import type { ILayerView } from "@esWebAPI/es/model/Layer";
import type { IEventChannel } from "@esWebAPI/es/model/Models";

export default class SpinnerModule {
    private readonly parentElement: HTMLElement;
    private readonly eventChannel: IEventChannel;
    private activeTasks: string[];
    private activeTaskTimings: number[];
    private spinnerTimeout: number|null;

    //var spinner = this;
    //var spinnerTimeout;

    /**
     * map spinner
     * parentElement : dom element where it gets prepended
     */
    constructor(parentElement: HTMLElement, eventChannel: IEventChannel) {
        this.parentElement = parentElement;
        this.eventChannel = eventChannel;

        this.activeTasks = [];
        this.activeTaskTimings = [];
        this.spinnerTimeout = null;

        this.addListeners = this.addListeners.bind(this);
        this.start = this.start.bind(this);
        this.activateSpinner = this.activateSpinner.bind(this);
        this.deactivateSpinner = this.deactivateSpinner.bind(this);
        this.reviewStateOnPageFocus = this.reviewStateOnPageFocus.bind(this);
        this.stop = this.stop.bind(this);
        this.forceStop = this.forceStop.bind(this);
        this.getActiveTasks = this.getActiveTasks.bind(this);

        $(parentElement).prepend($("<div/>", {"class" : "mapSpinner"}).append($("<div/>")));
        this.addListeners();
    }

    /**
     * 
     */
    private addListeners() {
        // TODO: it would be better if components that wanted to use the spinner set up their listeners instead of the spinner itself adding listeners to other components
        this.eventChannel.addListener("onGeneratingTilesStart", () => {
            this.start("GeneratingTiles");
        });

        this.eventChannel.addListener("onGeneratingTilesFinish", () => {
            this.stop("GeneratingTiles");
        });

        this.eventChannel.addListener("onTerritoryLayerLoadStart", (layerView: ILayerView) => {
            // using title for tooltip. If a territory layer title were to be changed between load start and load end then end would not trigger but that shouldn't ever happen
            this.start("TerritoryLayerLoad - " + layerView.title);
        });

        this.eventChannel.addListener("onTerritoryLayerLoadFinish", (layerView: ILayerView) => {
            this.stop("TerritoryLayerLoad - " + layerView.title);
        });

        this.eventChannel.addListener("onTerritoryDrawStart", () => {
            if (!this.activeTasks.includes("TerritoryDrawTiles")) {
                this.start("TerritoryDrawTiles");
            }
        });

        this.eventChannel.addListener("onTerritoryDrawFinish", (key) => {
            if (this.activeTasks.includes("TerritoryDrawTiles")) {
                this.stop("TerritoryDrawTiles");
            }
        });
    }

    /**
     * Begin showing non-intrusive "spinner" i.e. loading bar at top of map
     *
     * @param taskId task for which spinner is activating. A corresponding #stop(taskId) must be called.
     * @param timeout optional: time in ms before spinner will display. useful to prevent "flickery" appearance in cases where an action can take a long time but sometimes is fast.
     */
    start(taskId: string, timeout?: number) {
        //console.log("spinner_start", taskId);
        if (this.spinnerTimeout) {
            clearTimeout(this.spinnerTimeout);
        }

        this.activeTasks.push(taskId);
        this.activeTaskTimings.push(Date.now());
        if (!timeout || timeout <= 0) {
            window.requestAnimationFrame(this.activateSpinner);
        } else {
            this.spinnerTimeout = setTimeout(() => {
                window.requestAnimationFrame(this.activateSpinner);
            }, timeout ? timeout : 500);
        }
    }

    /**
     * 
     */
    private activateSpinner() {
        if(!$(this.parentElement).hasClass("loadingMap")){
            $(this.parentElement).addClass("loadingMap");
        }

        $(".mapSpinner").attr("title", this.activeTasks.toString());
    }

    /**
     * 
     */
    private deactivateSpinner() {
        //console.log("spinner_ deactivateSpinner called");
        clearTimeout(this.spinnerTimeout);
        $(this.parentElement).removeClass("loadingMap");
    }

    /**
     * 
     */
    reviewStateOnPageFocus() {
        if (this.activeTasks.length === 0 && $(this.parentElement).hasClass("loadingMap")) {
            this.deactivateSpinner();
        }
    }

    /**
     * 
     * @param taskId 
     */
    stop(taskId: string) {
        //console.log("spinner_stop", taskId);
        const taskIndex = this.activeTasks.indexOf(taskId);
        if (taskIndex < 0) {
            //console.log("Spinner : called stop() with taskId " + taskId + " which is not active");
            return;
        }

        if (es.util.EventChannel_logging) {
            console.log("Spinner task " + taskId + " complete. Took " + (Date.now() - this.activeTaskTimings[taskIndex]) + " ms");
        }

        // When a stop is called or a specific id, assume that the stop is applicable to all tasks with same id
        for (let i = this.activeTasks.length; i-- > 0;) {
            if (this.activeTasks[i] == taskId) {
                this.activeTasks.splice(i, 1);
                this.activeTaskTimings.splice(i, 1);
            }
        }

        if (this.activeTasks.length == 0) {
            this.deactivateSpinner();
        } else {
            $(".mapSpinner").attr("title", this.activeTasks.toString());
        }
    }

    /**
     * 
     */
    forceStop() {
        this.activeTasks = [];
        this.activeTaskTimings = [];
        this.deactivateSpinner();
    }

    /**
     * 
     * @returns 
     */
    getActiveTasks(): string[] {
        return this.activeTasks;
    }
}
